import {jwtDecode} from 'jwt-decode';
import { BASE_URL } from '../config';

export async function login(email, password) {
    try {
        const response = await fetch(BASE_URL + '/user/login', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ email, password }),
        });

        const responseBody = await response.json();
        console.log(responseBody);

        if (response.status === 200) {
            localStorage.setItem('accessToken', responseBody.access);
            localStorage.setItem('refreshToken', responseBody.refresh);

            // 15min accessToken duration
            const expiryTime = Date.now() + (15 * 60 * 1000);
            localStorage.setItem('access_token_expiry', expiryTime);
            localStorage.setItem('email', jwtDecode(responseBody.access)['user_id']);
            console.log(jwtDecode(responseBody.access)['user_id']);
            console.log(response.status);

            return response.status; // Contains the access and refresh tokens
        } else {
            throw new Error(responseBody.detail || 'Login API failed');
        }

    } catch (error) {
        console.error('Error logging in user:', error.message);
        throw new Error(`Failed to log in user: ${error.message}`);
    }
}

export async function register(email, password, firstName, lastName, birthday, tikTokName) {
    try {
        const response = await fetch(BASE_URL + '/user/register', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({email, password, firstName, lastName, birthday, tikTokName}),
        });

        // Log the status and the response body for debugging
        const responseBody = await response.json();

        if (response.status === 201) {
            return response.status;
        } else {
            throw new Error(responseBody.message || 'Registration failed');
        }

    } catch (error) {
        // Handle network errors, fetch API errors, or other exceptions
        console.error('Error registering user:', error.message);
        throw new Error(`Failed to register user: ${error.message}`);
    }
}

export async function refreshToken() {
    try {
        const response = await fetch(BASE_URL + '/user/login/refresh', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ refresh: localStorage.getItem('refreshToken')}),
        });

        const responseBody = await response.json();

        if (response.ok) {
            console.log('Access token refreshed!');
            localStorage.setItem('accessToken', responseBody.access);

            return response.status;
        } else {
            localStorage.clear();
            throw new Error(response.detail || 'Login API failed');
        }
    }
    catch(error) {
        throw new Error(`Failed to refresh token: ${error.message}`);
    }
}

export async function getUserDetails() {
    const accessToken = localStorage.getItem('accessToken');
    if (accessToken) {
        console.log(accessToken);
    }
    try {
        const response = await fetch(BASE_URL + '/user/data/get', {
            method: 'GET',
            headers: {
                "Authorization": `Bearer ${accessToken}`,
                'Content-Type': 'application/json',
            },
        });

        const responseBody = await response.json();
        console.log(responseBody);
        return responseBody;
    } catch (error) {
        console.error(error);
    }
}

export async function updateAddress(address, city, postcode, state) {
    const accessToken = localStorage.getItem('accessToken');
    if (accessToken) {
        console.log(accessToken);
    }
    try {
        const response = await fetch(BASE_URL + '/user/data/post', {
            method: 'POST',
            headers: {
                "Authorization": `Bearer ${accessToken}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                address:address,
                city:city,
                postcode:postcode,
                state:state
            })
        });

        const responseBody = await response.json();
        console.log(responseBody);
    } catch (error) {
        console.error(error);
    }
}